export function getServiceGatewayURL(serviceName: string): string | undefined {
    try {
        return `${window.location.origin}/service/${serviceName}`;
    } catch {
        return undefined;
    }
}
